import React, { useState, useEffect, useRef } from "react";
import { Td, Tr } from "@lightspeed/cirrus-table";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import { useDispatch, useSelector } from "react-redux";
import * as databaseActions from "../../../redux/actions/databaseActions";
import QuickBooksClassDepartmentField from "../QuickBooksClassDepartmentField";

const Row = ({ item, accountsList, classList, customersList = [], hideClassDepartmentColumn = false }) => {
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui);
  const userState = useSelector((state) => state.userState);
  const database = useSelector((state) => state.database);

  const [edit, setEdit] = useState(false);
  const [changed, setChanged] = useState(false);
  const [inputBox1, setInputBox1] = useState("");
  const [inputBox2, setInputBox2] = useState("");
  const [inputBox3, setInputBox3] = useState("");
  const [inputBox4, setInputBox4] = useState("");
  const [inputBox5, setInputBox5] = useState("");
  const [inputBox6, setInputBox6] = useState("");
  const [customerId, setCustomerId] = useState("");

  const normalAccount = item.account_id === null ? "" : item.account_id;
  const normalAccountDescription =
    item.account_description === null ? "" : item.account_description;
  const normalID = item.over_short_id === null ? "" : item.over_short_id;
  const normalNAME = item.over_short_name === null ? "" : item.over_short_name;
  const ClassDepartmentLocation =
    item.class_department_location === null ? "" : item.class_department_location;
  const normalCustomer = item?.qb_customer_id ?? item?.customer_id ?? "";

  const [showDropdown, setShowDropdown] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchInputRef = useRef(null);


  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [customerSearchText, setCustomerSearchText] = useState("");
  const customerSearchInputRef = useRef(null);

  useEffect(() => {
    if (showDropdown && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [showDropdown]);

  useEffect(() => {
    if (showCustomerDropdown && customerSearchInputRef.current) {
      customerSearchInputRef.current.focus();
    }
  }, [showCustomerDropdown]);

  useEffect(() => {
    setInputBox1(normalAccount);
    setInputBox2(normalAccountDescription);
    setInputBox3(normalID);
    setInputBox4(normalNAME);
    setInputBox5(ClassDepartmentLocation);
    setInputBox6(normalCustomer);
    setCustomerId(item.customer_id ? String(item.customer_id) : "");

    setEdit(false);
  }, [
    normalAccount,
    normalAccountDescription,
    normalID,
    normalNAME,
    ClassDepartmentLocation,
    normalCustomer,
    item.customer_id,
  ]);

  useEffect(() => {
    if (
      normalAccount === inputBox1 &&
      normalAccountDescription === inputBox2 &&
      normalID === inputBox3 &&
      normalNAME === inputBox4 &&
      ClassDepartmentLocation === inputBox5 &&
      normalCustomer === inputBox6
    ) {
      setChanged(false);
    } else {
      setChanged(true);
    }
  }, [
    inputBox1,
    inputBox2,
    inputBox3,
    inputBox4,
    inputBox5,
    inputBox6,
    normalAccount,
    normalAccountDescription,
    normalID,
    normalNAME,
    ClassDepartmentLocation,
    normalCustomer,
  ]);


  const filteredCustomers = customersList.filter((customer) => {
    const id = (customer?.id ?? "").toString().toLowerCase();
    const desc = (customer?.description ?? "").toString().toLowerCase();
    const search = customerSearchText.toLowerCase();
    return id.includes(search) || desc.includes(search);
  });

  const handleUpdate = () => {
    const qbCustomerValue = (inputBox6 ?? "").toString().trim() || null;
    const internalCustomerId = (customerId ?? "").toString().trim() || null;

    if (database.currentCompany.type === "RETAIL") {
      dispatch(
        databaseActions.updateRetailPaymentDeferred(
          userState.user.user_id,
          item.company_id,
          database.currentShop.shop_id,
          inputBox1,
          inputBox2,
          item.paymenttype_id,
          inputBox3,
          inputBox4,
          inputBox5,
          qbCustomerValue,
          internalCustomerId,
          null,
          null,
          databaseActions.getShopPayments(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        )
      );
    }

    if (database.currentCompany.type === "RETAILX") {
      dispatch(
        databaseActions.updateRetailPaymentX(
          userState.user.user_id,
          item.company_id,
          database.currentShop.shop_id,
          inputBox1,
          inputBox2,
          item.paymenttype_id,
          inputBox3,
          inputBox4,
          inputBox5,
          qbCustomerValue,
          internalCustomerId,
          null,
          null,
          databaseActions.getShopPaymentsX(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        )
      );
    }

    if (database.currentCompany.type === "RESTOK") {
      if (database.currentCompany.direct) {
        dispatch(
          databaseActions.updateRestoPaymentsK(
            userState.user.user_id,
            item.company_id,
            item.paymenttype_id,
            inputBox1,
            inputBox2,
            0,
            inputBox5,
            qbCustomerValue,
            internalCustomerId,
            null,
            undefined,
            databaseActions.patchCurrentAreaPayment(item.paymenttype_id, {
              account_id: inputBox1,
              account_description: inputBox2,
              class_department_location: inputBox5,
              qb_customer_id: qbCustomerValue,
              customer_id: internalCustomerId,
            })
          )
        );
      } else {
        dispatch(
          databaseActions.updateRestoPaymentsK(
            userState.user.user_id,
            item.company_id,
            item.paymenttype_id,
            inputBox1,
            inputBox2,
            database.currentShop.area_id,
            inputBox5,
            qbCustomerValue,
            internalCustomerId,
            null,
            undefined,
            databaseActions.patchCurrentAreaPayment(item.paymenttype_id, {
              account_id: inputBox1,
              account_description: inputBox2,
              class_department_location: inputBox5,
              qb_customer_id: qbCustomerValue,
              customer_id: internalCustomerId,
            })
          )
        );
      }
    }

    if (database.currentCompany.type === "RESTO") {
      if (database.currentCompany.direct) {
        dispatch(
          databaseActions.updateRestoPayments(
            userState.user.user_id,
            item.company_id,
            item.paymenttype_id,
            inputBox1,
            inputBox2,
            0,
            inputBox5,
            qbCustomerValue,
            internalCustomerId,
            databaseActions.getAreaPayments(
              userState.user.user_id,
              database.currentCompany.id,
              0
            )
          )
        );
      } else {
        dispatch(
          databaseActions.updateRestoPayments(
            userState.user.user_id,
            item.company_id,
            item.paymenttype_id,
            inputBox1,
            inputBox2,
            database.currentShop.area_id,
            inputBox5,
            qbCustomerValue,
            internalCustomerId,
            databaseActions.getAreaPayments(
              userState.user.user_id,
              database.currentCompany.id,
              database.currentShop.area_id
            )
          )
        );
      }
    }

    setEdit(false);
    setShowDropdown(false);
    setShowCustomerDropdown(false);
  };

  return (
    <Tr
      textAlign="right"
      className={`${ui.theme === "flame" ? "" : "dark-table-row"}`}
      onDoubleClick={() => {
        setInputBox1(normalAccount);
        setInputBox2(normalAccountDescription);
        setInputBox3(normalID);
        setInputBox4(normalNAME);
        setInputBox5(ClassDepartmentLocation);
        setInputBox6(normalCustomer);
        setCustomerId(item.customer_id ? String(item.customer_id) : "");
        setEdit(true);
      }}
    >
      {/* POS */}
      <Td width="15%" className="td-pos">
        {item.company_id}
      </Td>

      <Td width="15%" className="td-pos">
        {item.paymenttype_id}
      </Td>

      <Td width="20%" className="td-pos td-pos-last">
        {item.paymenttypeid_name}
      </Td>

      {/* ACCOUNTING */}
      <Td
        width="20%"
        className="td-acc td-acc-first"
        style={{ position: "relative" }}
      >
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox1}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper" style={{ position: "relative" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox1}
                onChange={(e) => setInputBox1(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
              <span
                style={{
                  marginLeft: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                  userSelect: "none",
                }}
                onClick={() => setShowDropdown((prev) => !prev)}
              >
                ⏷
              </span>
            </div>

            {showDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  zIndex: 1000,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  width: "450px",
                  minWidth: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                  marginTop: "4px",
                }}
              >
                <div style={{ padding: "4px" }}>
                  <input
                    ref={searchInputRef}
                    type="text"
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "6px",
                      fontSize: "14px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                </div>

                {accountsList
                  .filter(
                    (acc) =>
                      acc.id.toLowerCase().includes(searchText.toLowerCase()) ||
                      acc.description.toLowerCase().includes(searchText.toLowerCase())
                  )
                  .map((acc) => {
                    return (
                      <div
                        key={acc.paymenttype_id}
                        style={{
                          padding: "6px 8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => {
                          setInputBox1(acc.id);
                          setInputBox2(acc.description);
                          setChanged(true);
                          setShowDropdown(false);
                          setSearchText("");
                        }}
                      >
                        <strong>{acc.id}</strong> — {acc.description}
                      </div>
                    );
                  })}

                {accountsList.filter(
                  (acc) =>
                    acc.id.toLowerCase().includes(searchText.toLowerCase()) ||
                    acc.description.toLowerCase().includes(searchText.toLowerCase())
                ).length === 0 && (
                  <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                )}
              </div>
            )}
          </div>
        )}
      </Td>

      <Td width="20%" className="td-acc">
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox2}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox2}
                onChange={(e) => setInputBox2(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>

      <Td width="20%" className="td-acc" style={{ position: "relative", display: hideClassDepartmentColumn ? "none" : undefined }}>
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox5}
            <div className="flex" />
          </div>
        )}
        {edit && (
          <div className="row-input-wrapper" style={{ position: "relative" }}>
            <QuickBooksClassDepartmentField
              value={inputBox5}
              onChange={(value) => {
                setInputBox5(value);
                setChanged(true);
              }}
              classDepartments={classList}
              onEnter={handleUpdate}
            />
          </div>
        )}
      </Td>

      <Td width="20%" className="td-acc" style={{ position: "relative" }}>
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox6}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper" style={{ position: "relative" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox6}
                onChange={(e) => {
                  setInputBox6(e.target.value);
                  setChanged(true);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
              <span
                style={{
                  marginLeft: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                  userSelect: "none",
                }}
                onClick={() => {
                  setShowCustomerDropdown((prev) => !prev);
                  setCustomerSearchText("");
                }}
              >
                â·
              </span>
            </div>

            {showCustomerDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  zIndex: 1000,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  width: "450px",
                  minWidth: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                  marginTop: "4px",
                }}
              >
                <div style={{ padding: "4px" }}>
                  <input
                    ref={customerSearchInputRef}
                    type="text"
                    placeholder="Search..."
                    value={customerSearchText}
                    onChange={(e) => setCustomerSearchText(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "6px",
                      fontSize: "14px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const first = filteredCustomers[0];
                        if (first) {
                          setInputBox6(String(first.id));
                          setCustomerId(String(first.id));
                          setChanged(true);
                          setShowCustomerDropdown(false);
                          setCustomerSearchText("");
                        }
                      }
                    }}
                  />
                </div>

                {filteredCustomers.map((customer) => (
                  <div
                    key={customer.id}
                    style={{
                      padding: "6px 8px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                    }}
                    onClick={() => {
                      setInputBox6(String(customer.id));
                      setCustomerId(String(customer.id));
                      setChanged(true);
                      setShowCustomerDropdown(false);
                      setCustomerSearchText("");
                    }}
                  >
                    <strong>{customer.id}</strong> â€” {customer.description}
                  </div>
                ))}

                {filteredCustomers.length === 0 && (
                  <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                )}
              </div>
            )}
          </div>
        )}
      </Td>

      <Td width="20%" className="td-acc">
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox3}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox3}
                onChange={(e) => setInputBox3(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>

      <Td width="20%" className="td-acc">
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox4}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox4}
                onChange={(e) => setInputBox4(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>

      <Td width="10%" textAlign="right" className="td-acc">
        {!edit && (
          <div className="row-input-wrapper-end">
            <Button
              onClick={(_) => {
                setInputBox1(normalAccount);
                setInputBox2(normalAccountDescription);
                setInputBox3(normalID);
                setInputBox4(normalNAME);
                setInputBox5(ClassDepartmentLocation);
                setInputBox6(normalCustomer);
                setCustomerId(item.customer_id ? String(item.customer_id) : "");
                setEdit(true);
              }}
              size="small"
              fill="true"
            >
              Edit
            </Button>
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper-end">
            {changed ? (
              <Button onClick={handleUpdate} size="small" fill="true">
                Update
              </Button>
            ) : inputBox1 === "" &&
              inputBox2 === "" &&
              inputBox3 === "" &&
              inputBox4 === "" ? null : (
              <Button
                onClick={(_) => {
                  setInputBox1(normalAccount);
                  setInputBox2(normalAccountDescription);
                  setInputBox3(normalID);
                  setInputBox4(normalNAME);
                  setInputBox5(ClassDepartmentLocation);
                  setInputBox6(normalCustomer);
                  setCustomerId(item.customer_id ? String(item.customer_id) : "");
                  setEdit(false);
                }}
                size="small"
                fill="true"
              >
                Cancel
              </Button>
            )}
          </div>
        )}
      </Td>
    </Tr>
  );
};

export default Row;